import {
    getStatusStartTime,
    getStatusEndTime,
    clampDate,
} from 'routes/Reports/models/helpers/turbineStatusChart.helper';
import { getId } from 'common/data.utils';
import { getEarliestBeginDate, getLatestEndDate, REPORT_STATUSES } from 'lib/components/Timeline/Timeline.helpers';

export function collectTurbineData(data) {
    return data.map((item) => {
        const id = getId(item);
        const {
            total_number_of_persons_visited,
            total_generation_vs_average_generation,
            notes_count,
            restrictions_count,
            exceptions_count,
            total_generation,
        } = item;

        return {
            key: id,
            id,
            generation: total_generation,
            average: Math.round(total_generation_vs_average_generation * 100) / 100,
            persons: total_number_of_persons_visited,
            hasNote: notes_count > 0,
            notes: notes_count,
            hasRestriction: restrictions_count > 0,
            restrictions: restrictions_count,
            hasAlarm: exceptions_count > 0,
            alarms: exceptions_count,
        };
    });
}

export const isTurbine = (ids) => (item) => ids.includes(item.key);

export function collectTurbineStateData(data, turbineSummaries, selectedDate) {
    const chartData = [];

    const earliest = getEarliestBeginDate(selectedDate);
    const latest = getLatestEndDate(selectedDate);

    turbineSummaries.forEach((turbine) => {
        const items = data.filter(
            (item) =>
                getId(item) === turbine.id &&
                item.state !== REPORT_STATUSES.FAULT &&
                item.state !== REPORT_STATUSES.WORKING
        );
        if (items.length > 0) {
            items.forEach((item) => {
                const beginDate = getStatusStartTime(item);
                const endDate = getStatusEndTime(item, beginDate);
                const { state, ...rest } = item;

                chartData.push({
                    turbineData: { ...turbine },
                    debugData: item,
                    key: turbine.id,
                    type: state,
                    beginDate: clampDate(beginDate, earliest, latest),
                    endDate: clampDate(endDate, earliest, latest),
                    ...rest,
                });
            });
        } else {
            // Create empty item for chart row
            chartData.push({
                turbineData: turbine,
                key: turbine.id,
            });
        }
    });
    return chartData;
}

export function sortTurbineStatuses(statuses, sortKey, ascending) {
    statuses.sort((a, b) => {
        let left = a.turbineData[sortKey];
        let right = b.turbineData[sortKey];

        if (typeof left === 'string' && typeof right === 'string') {
            left = left.toUpperCase();
            right = right.toUpperCase();
        }

        const result = left >= right ? 1 : -1;

        return ascending ? result : result * -1;
    });
}

export function filterTurbineData(storeFilter, filterKey, statuses, summaries) {
    let filter = [...storeFilter];

    const hasIndex = filter.indexOf(filterKey);
    if (hasIndex === -1) {
        filter.push(filterKey);
    } else {
        filter = [...filter.slice(0, hasIndex), ...filter.slice(hasIndex + 1)];
    }
    let filteredStatuses = [];
    let filteredSummaries = [];

    if (!filter.length) {
        filteredStatuses = statuses;
        filteredSummaries = summaries;
    } else {
        filteredStatuses = statuses.filter((i) => filter.indexOf(i.type) > -1);
        const filteredTurbineKeys = filteredStatuses.map((i) => i.key);
        filteredSummaries = summaries.filter((i) => filteredTurbineKeys.indexOf(i.id) !== -1);
    }

    return { filter, filteredStatuses, filteredSummaries };
}
